/* WJW Increment 46: mobile-only account-link placement.
   Reuse the existing Helium-inserted Edit account link; never invent its URL. */
(() => {
  'use strict';
  const mq = window.matchMedia('(max-width: 749px)');
  let watchedPanel = null;
  let observer = null;

  function tidy() {
    if (!mq.matches) return;
    const panel = document.querySelector('#mobile-app-menu-drawer .mobile-app-menu-panel');
    const account = panel?.querySelector('.wjw-mobile-account[data-wjw-account-state="signed-in"]');
    const actions = account?.querySelector('[data-wjw-account-actions]');
    if (!panel || !actions) return;
    // Only the exact customer-fields action inside the mobile menu is eligible.
    // Do not move navigation links, sign-out links, or account controls elsewhere.
    const match = Array.from(panel.querySelectorAll('a')).find(a =>
      a.parentElement !== actions &&
      a.textContent.trim().toLowerCase() === 'edit account' &&
      a.getAttribute('href') && a.getAttribute('href') !== '#' &&
      !/^javascript:/i.test(a.getAttribute('href').trim())
    );
    if (!match) return;
    match.classList.add('wjw-mobile-account__edit');
    actions.insertBefore(match, actions.firstChild);
  }

  function initialize() {
    const panel = document.querySelector('#mobile-app-menu-drawer .mobile-app-menu-panel');
    if (!panel) return;
    tidy();
    if (watchedPanel === panel) return;
    if (observer) observer.disconnect();
    watchedPanel = panel;
    // Some customer-field integrations render after DOMContentLoaded.
    observer = new MutationObserver(tidy);
    observer.observe(panel, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  mq.addEventListener?.('change', tidy);
})();
